import { Helmet } from "react-helmet-async";
import Button from "../../components/ui/Button";

export default function Plumbing() {
  const name = "Plumbing";

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": `BuildBright ${name}`,
    "areaServed": "United States, US",
    "provider": { "@type": "LocalBusiness", "name": "BuildBright" },
  };

  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10">
      <Helmet>
        <title>BuildBright – Plumbing Nationwide</title>
        <meta name="description" content="Plumbing service by licensed local pros. Fast estimate requests." />
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Helmet>

      <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight">Plumbing</h1>
      <p className="mt-3 text-lg text-gray-700">Popular jobs: Drain cleaning, pipe repair, water heater installation, leak detection</p>

      <div className="mt-6 grid gap-4">
        <details className="rounded-xl border p-4">
          <summary className="font-semibold cursor-pointer">How long does a typical job take?</summary>
          <div className="mt-2 text-gray-700">Project timing varies by contractor availability, project scope, parts, permitting, and homeowner needs.</div>
        </details>
        <details className="rounded-xl border p-4">
          <summary className="font-semibold cursor-pointer">Who handles the project work?</summary>
          <div className="mt-2 text-gray-700">BuildBright helps organize the project request. Licensing, insurance, warranty terms, pricing, and workmanship are handled by the participating contractor.</div>
        </details>
      </div>

      <div className="mt-8">
        <Button as="a" href="#/get-quotes">Submit Project Request</Button>
      </div>
    </div>
  );
}
